const benefits = {
  cancellation_policy: {
    title: 'Cancellation policy',
    this_is_not_insurance: 'THIS IS NOT INSURANCE',
    faq: {
      items: [
        {
          title: 'Disclosures:',
          htmlContent: '<ol><li>This plan is not a health insurance policy.</li><li>This plan provides discounts for medical services at certain health care providers.</li><li>This plan does not make payments directly to the providers of medical services.</li><li>The member is obligated to pay for all discounted health care services at the point of service. The discounts may vary based on service, provider, and geographic location.</li></ol>'
        },
        {
          title: 'Cancellation Policy:',
          htmlContent: 'To terminate or cancel the member agreement please call (726) 202-1213 or send a written cancellation notice to Attn: Member Services at P.O. Box 803475, Dallas, TX 75367-1309. This notice must include your name, member ID number, and be submitted at least three (3) days prior to your next scheduled payment date. This agreement can be canceled for non-payment. If a membership is cancelled for any reason other than non-payment, the member shall receive a pro-rata reimbursement of all periodic charges.'
        },
        {
          title: '30-day money back guarantee:',
          htmlContent: 'If you cancel for any reason within 30 days after the effective date, you will receive a full refund of paid membership fees.'
        },
        {
          title: 'Issue Resolution:',
          htmlContent: 'For any concerns or complaints when using your membership, please call (726) 202-1213 for assistance. Your issue will be researched, and a resolution reached within 3 business days.'
        }
      ]
    }
  }
};

export default benefits;
